import { GetAllWfsLogRequest } from "../types/WfsLog/GetAllWfsLogRequest";
import { WfsLog } from "../types/WfsLog/WfsLog";
import { PaginationResult } from "../types/PaginiationResult";
import { ResponseTimes } from "../types/WfsLog/ResponseTimes";
import { GetWfsResponseTimeRequest } from "../types/WfsLog/GetWfsResponseTimeRequest";
import { DateTime } from "luxon";
import { AxiosInstance } from "axios";

export default class WfsLogService {
  private _endpoint = "WfsLog";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async getAllWfsLogs(
    request: GetAllWfsLogRequest,
  ): Promise<PaginationResult<WfsLog>> {
    const queryString = this.convertToQueryString(request);
    return this._client
      .get<any>(`${this._endpoint}/${queryString}`)
      .then((response) => {
        return response.data;
      });
  }

  public async getWfsResponseTimes(
    request: GetWfsResponseTimeRequest,
  ): Promise<ResponseTimes> {
    const queryString = this.objectToQueryString(request);
    return this._client
      .get<any>(`${this._endpoint}/GetResponseTimes${queryString}`)
      .then((response) => {
        return response.data;
      });
  }

  private convertToQueryString = (request: GetAllWfsLogRequest) => {
    // convert GetAllWfsRequest to a query string
    let queryString = `?startIndex=${request.startIndex}&count=${request.count}`;
    if (request.startTime) {
      queryString += `&startTime=${request.startTime.toUTC().toISO({
        includeOffset: false,
      })}`;
    }
    if (request.endTime) {
      queryString += `&endTime=${request.endTime.toUTC().toISO({
        includeOffset: false,
      })}`;
    }
    if (request.userId) {
      queryString += `&userId=${request.userId}`;
    }
    if (request.layer) {
      queryString += `&layer=${request.layer}`;
    }
    return queryString;
  };

  private objectToQueryString = (obj: any) => {
    const parts = ["?"];

    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
        let value = obj[key];

        if (value instanceof DateTime) {
          // Convert Date objects to ISO strings
          value = value.toUTC().toISO({ includeOffset: false });
        }

        parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
      }
    }

    return parts.join("&");
  };
}
